import { SentimentWordConfig } from './types';

export const enSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'achieved',
        'active',
        'approved',
        'awesome',
        'best',
        'brilliant',
        'calm',
        'celebrate',
        'clear',
        'complete',
        'completed',
        'confident',
        'delighted',
        'done',
        'easy',
        'effective',
        'excellent',
        'excited',
        'favourite',
        'fix',
        'fixed',
        'forward',
        'gain',
        'glad',
        'good',
        'green',
        'growth',
        'helpful',
        'healthy',
        'great',
        'happy',
        'hopeful',
        'improvement',
        'improved',
        'improve',
        'inspiring',
        'joy',
        'kind',
        'love',
        'optimistic',
        'passed',
        'perfect',
        'positive',
        'progress',
        'ready',
        'relief',
        'resolved',
        'reward',
        'safe',
        'secure',
        'smooth',
        'stable',
        'strong',
        'success',
        'supported',
        'useful',
        'valuable',
        'win',
        'winning',
        'wonderful',
        'accomplished',
        'advancing',
        'assured',
        'beneficial',
        'boost',
        'bright',
        'capable',
        'celebrated',
        'comfort',
        'dependable',
        'easier',
        'empowered',
        'encouraging',
        'energised',
        'enjoyed',
        'fair',
        'fantastic',
        'flourish',
        'growing',
        'honest',
        'impressive',
        'kindness',
        'meaningful',
        'neat',
        'outstanding',
        'peaceful',
        'pleasant',
        'protected',
        'recovered',
        'refreshed',
        'reliable',
        'restored',
        'satisfying',
        'thriving',
        'uplifted',
        'welcomed',
        'worthy',
        'vibrant',
        'victorious',
        'trusted',
    ]),
    negativeWords: new Set([
        'angry',
        'annoying',
        'anxious',
        'awful',
        'blocked',
        'blocking',
        'broke',
        'broken',
        'chaos',
        'confused',
        'crash',
        'crashed',
        'danger',
        'dangerous',
        'dead',
        'decline',
        'delay',
        'delayed',
        'difficult',
        'disaster',
        'down',
        'error',
        'failed',
        'failing',
        'failure',
        'fault',
        'fear',
        'frustrated',
        'frustrating',
        'hard',
        'harm',
        'hate',
        'issue',
        'lag',
        'mess',
        'negative',
        'overdue',
        'pain',
        'panic',
        'poor',
        'problem',
        'red',
        'regression',
        'rejected',
        'risk',
        'risky',
        'sad',
        'scary',
        'slow',
        'stalled',
        'stuck',
        'terrible',
        'threat',
        'trouble',
        'ugly',
        'unsafe',
        'weak',
        'worry',
        'worried',
        'worse',
        'worst',
        'bad',
        'bug',
        'late',
        'urgent',
        'afraid',
        'alarming',
        'badly',
        'barrier',
        'bleak',
        'collapse',
        'complicated',
        'concern',
        'damaged',
        'damaging',
        'defect',
        'depressed',
        'disappointing',
        'disturbing',
        'drained',
        'emergency',
        'fearful',
        'fragile',
        'guilt',
        'hostile',
        'hurt',
        'incorrect',
        'instability',
        'irritating',
        'loss',
        'mistake',
        'obstacle',
        'overwhelmed',
        'pressure',
        'sadness',
        'stressful',
        'tense',
        'toxic',
        'unpleasant',
        'vulnerable',
        'stop',
    ]),
};
